var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGirlImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 70.566,
    viewBox: "0 0 60 70.566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 4.751,
    x2: 0.5,
    y2: 3.752,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffaa96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f89c88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f28e7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ea8d7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e68c7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 883.7,
    x2: 0.5,
    y2: 882.46,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a365d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f1945"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25058",
    "data-name": "Group 25058",
    transform: "translate(-72 -195.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_158_7",
    "data-name": "Component 158 \\u2013 7",
    transform: "translate(72 207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42503",
    "data-name": "Path 42503",
    d: "M30,0A29.753,29.753,0,0,1,60,29.5,29.753,29.753,0,0,1,30,59,29.753,29.753,0,0,1,0,29.5,29.753,29.753,0,0,1,30,0Z",
    fill: "#ddb456"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25055",
    "data-name": "Group 25055",
    transform: "translate(78.658 195.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(6.104 4.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25045",
    "data-name": "Group 25045",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165104",
    "data-name": "Path 165104",
    d: "M169.538,120.949a179.255,179.255,0,0,0,.438,40.836h29.706s0-11.323-.459-25.058-5.606-20.191-5.606-20.191-13.666-9.755-24.08,4.414Z",
    transform: "translate(-166.269 -113.263)",
    fill: "#301818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165105",
    "data-name": "Path 165105",
    d: "M206.914,410.515c-.2-1.477,0-9.265,0-9.265l-5.287.4-5.287-.4s.2,7.764,0,9.265a15.311,15.311,0,0,1-8.08,4.808h26.774A15.208,15.208,0,0,1,206.914,410.515Z",
    transform: "translate(-183.595 -366.803)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165106",
    "data-name": "Path 165106",
    d: "M255.739,405s4.628,3.97,10.434,2.315l.08-6.064s-3.053,2.195-10.593.3l.08,3.451Z",
    transform: "translate(-242.932 -366.803)",
    fill: "#7c5639",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165107",
    "data-name": "Path 165107",
    d: "M209.279,471.235H180.93s4.928-2.3,5.8-3.487c.2-.3.419-.591.6-.916a15.027,15.027,0,0,0,.758-1.507l.02-.03a4.46,4.46,0,0,1,.26-.532,7.611,7.611,0,0,1,1.476.473l.086.962a4.716,4.716,0,0,0,1.531,2.34,5.485,5.485,0,0,0,3.69.984,6.5,6.5,0,0,0,3.366-.866s1.785-.879,1.921-1.794a2.465,2.465,0,0,0,.02-.435,1.923,1.923,0,0,0-.022-.2v-.992l1.5-.473a8.683,8.683,0,0,0,.239,1.153,5.275,5.275,0,0,0,.459,1.182,6.132,6.132,0,0,0,.6.886c.549.669,2.785,2.011,6.045,3.251Z",
    transform: "translate(-177.141 -422.714)",
    fill: "#a81a24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25044",
    "data-name": "Group 25044",
    transform: "translate(12.827 42.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165108",
    "data-name": "Path 165108",
    d: "M257.148,467.13l-.658.6",
    transform: "translate(-256.49 -467.13)",
    fill: "#1f3f0c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_165109",
    "data-name": "Path 165109",
    d: "M247.579,468.28s-.463,1.243,1.038,3.1a6.952,6.952,0,0,0,3.047,2.006,8.659,8.659,0,0,1-5.1-4.286l1.019-.822Z",
    transform: "translate(-234.921 -425.815)",
    fill: "#a81a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165110",
    "data-name": "Path 165110",
    d: "M331.13,470.04a8.838,8.838,0,0,1-1.069,1.443,8.97,8.97,0,0,1-2.511,1.92s2.892-.579,3.791-2.354C331.27,470.712,331.2,470.376,331.13,470.04Z",
    transform: "translate(-306.223 -427.364)",
    fill: "#a81a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165111",
    "data-name": "Path 165111",
    d: "M408.716,254.083c-.06.34-.159.639-.219.917v.02c-.6,1.955-1.536,2.414-1.895,3.312-.319.758-1.577,2.294-2.833.7h0s.6-6.484,1.057-7.641c0,0,.7-1.775,1.935-2.035,1.577-.359,2.554,1.736,1.955,4.728Z",
    transform: "translate(-373.326 -233.042)",
    fill: "#fc8f7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165112",
    "data-name": "Path 165112",
    d: "M406.538,268.573s2.494-3.611,3.691-3.85c1.177-.239.6,2.832.34,3.85a6.145,6.145,0,0,1-.6,1.616,14.391,14.391,0,0,0,.359-2.195c.08-1.416-.359-2.614-.878-2.494-.5.12-1.157,1.876-1.217,2.094s.34.559.319,1.655-.538,2.274-.818,2.255-.159-.9-.159-1.915-.8-.818-1.138-.159l.1-.858Z",
    transform: "translate(-375.677 -246.594)",
    fill: "#7c5639",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165113",
    "data-name": "Path 165113",
    d: "M406.26,289.207s.639-.977,1.018-.519c.379.439.1,1.655.4,1.816.3.14.7-.837.6-1.736-.06-.9-.439-1.7-.938-1.556l-1,1.157-.08.837Z",
    transform: "translate(-375.518 -266.391)",
    fill: "#7c5639",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165114",
    "data-name": "Path 165114",
    d: "M408.327,297.17c-.6,1.954-1.536,2.414-1.895,3.312-.319.758-1.577,2.294-2.833.7a1.733,1.733,0,0,0,1.536.379c.758-.279,1.018-1.018,1.336-1.556a9.023,9.023,0,0,0,1.855-2.832Z",
    transform: "translate(-373.176 -275.172)",
    fill: "#dd6b7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165115",
    "data-name": "Path 165115",
    d: "M149.434,254.083c.06.34.159.639.219.917v.02c.6,1.955,1.536,2.414,1.895,3.312.319.758,1.577,2.294,2.833.7h0s-.6-6.484-1.057-7.641c0,0-.7-1.775-1.935-2.035-1.556-.359-2.554,1.736-1.955,4.728Z",
    transform: "translate(-149.257 -233.042)",
    fill: "#fc8f7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165116",
    "data-name": "Path 165116",
    d: "M156.193,268.573s-2.494-3.611-3.691-3.85c-1.177-.239-.6,2.832-.34,3.85a6.145,6.145,0,0,0,.6,1.616,14.382,14.382,0,0,1-.359-2.195c-.08-1.416.359-2.614.878-2.494.5.12,1.157,1.876,1.216,2.094s-.34.559-.319,1.655.538,2.274.818,2.255.159-.9.159-1.915.8-.818,1.138-.159l-.1-.858Z",
    transform: "translate(-151.487 -246.594)",
    fill: "#7c5639",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165117",
    "data-name": "Path 165117",
    d: "M174.649,289.207s-.639-.977-1.018-.519c-.379.439-.1,1.655-.4,1.816-.3.14-.7-.837-.6-1.736.08-.9.439-1.7.938-1.556l1,1.157.08.837Z",
    transform: "translate(-169.823 -266.391)",
    fill: "#7c5639",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165118",
    "data-name": "Path 165118",
    d: "M152.74,297.17c.6,1.954,1.536,2.414,1.895,3.312.319.758,1.577,2.294,2.833.7a1.733,1.733,0,0,1-1.536.379c-.758-.279-1.018-1.018-1.336-1.556a9.024,9.024,0,0,1-1.855-2.832Z",
    transform: "translate(-152.323 -275.172)",
    fill: "#dd6b7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165119",
    "data-name": "Path 165119",
    d: "M205.709,147.475c-.01.042-.023.1-.04.179a23.579,23.579,0,0,1-1.527,4.365c-1.2,2.883-.861,2.787-1.544,3.895a10.877,10.877,0,0,1-2.035,2.414c-2.512,2.167-5.657,2.289-7.322,2.354-1.9.074-5.706.222-8.359-2.234a16.532,16.532,0,0,1-2.264-3.176,32.911,32.911,0,0,1-2.722-5.084c-.268-.667-.734-2.086-1.416-8.758-.379-3.71-.459-7.3.2-9.018a9.78,9.78,0,0,1,3.312-3.85,18.039,18.039,0,0,1,10.533-3.352c7.242,0,12.689,4.209,13.846,7.222,1.037,2.653.26,9.975-.658,15.043Z",
    transform: "translate(-174.728 -123.781)",
    fill: "#fc8f7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165120",
    "data-name": "Path 165120",
    d: "M210.95,386.24a2.647,2.647,0,0,0,.459.06A3.579,3.579,0,0,1,210.95,386.24Z",
    transform: "translate(-203.571 -353.588)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25054",
    "data-name": "Group 25054",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165157",
    "data-name": "Path 165157",
    d: "M14055.22-11784l-5.12,7.268h36.172l-5.616-7.268Z",
    transform: "translate(-14044.649 11836.615)",
    fill: "#a81a24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25053",
    "data-name": "Group 25053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25046",
    "data-name": "Group 25046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165121",
    "data-name": "Path 165121",
    d: "M98.412,106.039c.109-1.033.218-2.158.327-3.282v-.018c.036-.471.091-.925.127-1.415.362-4.08.689-8.487,1-12.386v-.127c.018-.182.018-.362.036-.562l.109-1.5a.77.77,0,0,1,.018-.127.311.311,0,0,1,.018-.127c0-.091.018-.182.018-.236v-.018c0-.073.018-.163.018-.218,0-.091.018-.163.018-.272.344-4.371.653-7.635.962-8.179a1.242,1.242,0,0,1,.744-.526h0c.218-.526.943-1.8,2.285-1.36,1.56.508,5.876,4.207,5.876,4.207l-1.669,2.086-.327.4s-2.285-.8-2.974.725.417,8.342,1.8,16.848A164.786,164.786,0,0,1,108.6,126.17c-.036,6.691-2.865,9.557-3.809,10.337a8.391,8.391,0,0,0,1.324-3.065,6.941,6.941,0,0,1-1.324,1.687c-.236.218-.471.4-.707.58h0a2.207,2.207,0,0,1-.4.236,5.458,5.458,0,0,1-2.611.762s1.5-.091,1.451-3.5c-.054-2.3-2.449-8.977-3.645-16.412v-.036c-.236-1.487-.435-3.011-.544-4.515-.054-.689-.091-1.36-.109-2.031V110.1a38.041,38.041,0,0,1,.182-4.062Z",
    transform: "translate(-98.23 -75.593)",
    fill: "#331b06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165122",
    "data-name": "Path 165122",
    d: "M110.056,154.4a8.37,8.37,0,0,1-1.324,3.065c.943-.78,3.754-3.627,3.809-10.337a165.068,165.068,0,0,0-1.813-26.223c-1.378-8.506-2.484-15.324-1.8-16.848s2.974-.725,2.974-.725l.327-.4-.036-.816s-4.606-2.9-6.166-2.775c-1.215.091-1.813,5.151-2.013,7.362,0,.091-.018.182-.018.272,0,.073-.018.127-.018.218v.018c0,.091-.018.182-.018.236a1168.117,1168.117,0,0,1-.036.254l-.109,1.5-.054.616v-.091c.127-1.089,1.142-9.684,2.376-9.757a4.763,4.763,0,0,1,2.249.489s-1.033-.309-2.756,6.148c-1.722,6.475-2.358,12.839-1.4,18.026.962,5.2,3.573,8.9,6.238,17.1,2.647,8.179-.417,12.658-.417,12.658s.417-6.637-3.337-16.068c-3.773-9.448-3.953-16.1-3.953-16.1-.036.489-.091.962-.127,1.415v.018a36.314,36.314,0,0,0,2.049,10.9c2.031,5.749,6.366,14.181,4.044,21.508a7.272,7.272,0,0,0,1.324-1.669Z",
    transform: "translate(-102.113 -96.496)",
    fill: "#563629",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165123",
    "data-name": "Path 165123",
    d: "M401.951,119.933c-.109-1.033-.218-2.158-.327-3.282v-.018c-.036-.471-.091-.925-.127-1.415-.362-4.08-.689-8.487-1-12.386V102.7c-.018-.182-.018-.362-.036-.562l-.109-1.5a.771.771,0,0,0-.018-.127.311.311,0,0,0-.018-.127c0-.091-.018-.182-.018-.236v-.018c0-.073-.018-.163-.018-.218,0,0,0-.018-.018-.272a23.357,23.357,0,0,0-.58-6.311c-.417-1.487-.834-1.74-.98-1.831-.508-.272-.925-.073-2.666.327a29.633,29.633,0,0,0-3.138.707,11.129,11.129,0,0,0-2.5,1.269l1.669,2.086.327.4s2.285-.8,2.974.725-.417,8.342-1.8,16.848a164.788,164.788,0,0,0-1.813,26.223c.036,6.691,2.865,9.557,3.809,10.337a8.392,8.392,0,0,1-1.324-3.065,6.941,6.941,0,0,0,1.324,1.687c.236.218.471.4.707.58a2.21,2.21,0,0,0,.4.236,5.459,5.459,0,0,0,2.611.762s-1.5-.091-1.451-3.5c.054-2.3,2.449-8.977,3.645-16.412v-.036c.236-1.487.435-3.011.544-4.515.054-.689.091-1.36.109-2.031v-.109a33.991,33.991,0,0,0-.182-4.08Z",
    transform: "translate(-355.452 -89.487)",
    fill: "#331b06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165124",
    "data-name": "Path 165124",
    d: "M403.867,154.4a8.37,8.37,0,0,0,1.324,3.065c-.943-.78-3.754-3.627-3.809-10.337-.109-13.873.635-20.783,1.813-26.223,0,0,2.411-11.153.127-15.233,0-.018-1.306-2.34-1.306-2.34h0l-.327-.4.036-.816s4.606-2.9,6.166-2.775c1.215.091,1.813,5.151,2.013,7.362,0,.091.018.182.018.272,0,.073.018.127.018.218v.018c0,.091.018.182.018.236a276.252,276.252,0,0,0,.036.254l.109,1.5.054.616v-.091c-.127-1.089-1.142-9.684-2.376-9.757a4.763,4.763,0,0,0-2.249.489s1.033-.309,2.756,6.148c1.723,6.475,2.358,12.839,1.4,18.026-.962,5.2-3.573,8.9-6.238,17.1-2.666,8.179.417,12.658.417,12.658s-.417-6.637,3.337-16.068c3.754-9.448,3.953-16.1,3.953-16.1.036.489.091.962.127,1.415v.018a36.314,36.314,0,0,1-2.049,10.9c-2.031,5.749-6.366,14.181-4.044,21.508a6.423,6.423,0,0,1-1.324-1.669Z",
    transform: "translate(-365.111 -96.496)",
    fill: "#563629",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165125",
    "data-name": "Path 165125",
    d: "M179.265,137.651a23.479,23.479,0,0,0,2.249-10.953c-.018-.78-.073-1.56-.145-2.322-.562-5.749-2.52-11.226-2.231-18.008.236-5.2-2.775-7.453-5.767-8.378h-.018a15.811,15.811,0,0,0-5.6-.616,14.6,14.6,0,0,0-7.091.907c-3.518,1.487-3.318,4.878-3.862,8.668-.562,3.791-1.524,10.772-4.588,14.87-2.865,3.826,1.051,12.441,4.08,13.528a7.449,7.449,0,0,1-4.969-4.316,10.6,10.6,0,0,1,1.2-10.755c1.886-2.756,1.886-9.158,1.886-9.158l-1.722,7.055s-2.14-11.189.145-17.337a6.973,6.973,0,0,1,1.669-2.7c4.788-4.5,9.449-3.3,12.948-3.3s9.593-.962,12.913,3.989l.218.327c3.029,5.259,1.269,19.695,1.324,23.9,0,.2.018.38.018.6.254,4.462,2.013,12.731-2.648,14Z",
    transform: "translate(-144.118 -92.407)",
    fill: "#331b06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165126",
    "data-name": "Path 165126",
    d: "M277.1,115.14c.345,0,6.946.182,9.285,3.137a7.83,7.83,0,0,1,.962,1.6c.725,1.669.562,3.047.707,4.806a22.352,22.352,0,0,0,1.051,4.642c1.723,6.475,3.355,8.777,2.72,12.531l-.907,4.679c-.589-1.177-1.394-2.813-2.328-4.786-1.707-3.605-1.938-4.314-2.044-5.216-.293-2.481.792-2.765.916-5.71.011-.266.2-6.111-2.726-7.588-1.608-.812-2.639.309-4.071-.533-1.647-.969-.725-3.519-2.335-4.8-.682-.544-1.939-.958-4.47-.2a4.6,4.6,0,0,1,2.316-2.3,3.934,3.934,0,0,1,.922-.249Z",
    transform: "translate(-252.852 -110.41)",
    fill: "#331b06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165127",
    "data-name": "Path 165127",
    d: "M193.119,110.468a10.028,10.028,0,0,0-13.344,3.269c-6.6,8.665-1.835,23.824-1.289,23.767.465-.048-2.646-11.124,2.691-15.294,2.663-2.081,5.405-.969,8.407-3.47,1.586-1.322,3.157-3.695,3.536-8.274Z",
    transform: "translate(-166.973 -105.186)",
    fill: "#331b06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165128",
    "data-name": "Path 165128",
    d: "M210.12,102.887a2.508,2.508,0,0,0,.453,1.415,4.7,4.7,0,0,0,1.958.6,5.527,5.527,0,0,1,1.542-1.378,5.153,5.153,0,0,1-2.358.109,1.165,1.165,0,0,1-.925-1.071l-.671.327Z",
    transform: "translate(-196.736 -99.334)",
    fill: "#331b06"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlImage);
export default __webpack_public_path__ + "static/media/girlImage.a18226a9e5b1c20aa427eb0a9b5dd69b.svg";
export { ForwardRef as ReactComponent };